(() => {
  function initialize(root) {
    if (root.dataset.productReady) return;
    root.dataset.productReady = 'true';
    const data = JSON.parse(root.querySelector('[data-ck-product-data]').textContent);
    const form = root.querySelector('.ck-product-form');
    const select = form.querySelector('[data-ck-variant-select]');
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency:data.currency});
    const photos = [...root.querySelectorAll('[data-ck-photo]')];
    const thumbs = [...root.querySelectorAll('[data-ck-thumbnail]')];
    let photoIndex = 0;
    let busy = false;
    const add = form.querySelector('[data-ck-add]');
    const addLabel = root.querySelector('[data-ck-add-label]');
    const originalLabel = addLabel?.textContent;
    const status = root.querySelector('[data-ck-cart-status]');
    function showPhoto(index) {
      if (!photos.length) return;
      photoIndex = (index + photos.length) % photos.length;
      photos.forEach((photo, i) => {photo.hidden = i !== photoIndex;});
      thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === photoIndex)));
      const counter = root.querySelector('[data-ck-gallery-counter]');
      if (counter) counter.textContent = `${photoIndex + 1} / ${photos.length}`;
      const sticker = root.querySelector('.ck-clinician-sticker');
      if (sticker) sticker.hidden = photoIndex !== 0;
      thumbs[photoIndex]?.scrollIntoView({block:'nearest', inline:'nearest', behavior:'instant'});
    }
    function variant() {return data.variants.find(v => String(v.id) === select.value);}
    function updatePrice() {
      const item = variant();
      if (!item) return;
      const plan = form.querySelector('[data-ck-selling-plan]');
      const allocation = plan && !plan.disabled ? item.plans.find(p => String(p.id) === plan.value) : null;
      const price = allocation?.price ?? item.price;
      const units = Math.max(1, parseInt(item.title, 10) || 1);
      root.querySelectorAll('[data-ck-total-price]').forEach(node => {node.textContent = money.format(price / 100);});
      root.querySelectorAll('[data-ck-per-jar-price]').forEach(node => {node.textContent = money.format(Math.floor(price / units) / 100);});
      root.querySelectorAll('[data-ck-serving-price]').forEach(node => {
        node.textContent = data.capsulesPerJar ? `${money.format(price / units / (data.capsulesPerJar / Math.max(1, data.capsulesPerServing)) / 100)} per serving` : '';
      });
      const description = root.querySelector('[data-ck-pack-description]');
      if (description) description.textContent = data.capsulesPerJar ? `${units * data.capsulesPerJar} Capsules` : item.title === 'Default Title' ? '' : item.title;
      if (add) add.disabled = busy || !item.available;
      if (addLabel && !busy) addLabel.textContent = item.available ? originalLabel : 'Sold out';
      root.querySelectorAll('[data-ck-pack]').forEach(radio => {radio.checked = radio.value === String(item.id);});
      const image = data.images.findIndex(i => i.id === item.imageId);
      if (image >= 0) showPhoto(image);
    }
    select?.addEventListener('change', () => {
      updatePrice();
      const next = new URL(location.href);
      next.searchParams.set('variant', select.value);
      history.replaceState({}, '', next);
    });
    root.querySelectorAll('[data-ck-pack]').forEach(radio => radio.addEventListener('change', () => {
      select.value = radio.value;
      select.dispatchEvent(new Event('change', {bubbles:true}));
    }));
    root.querySelectorAll('[data-ck-purchase-type]').forEach(radio => radio.addEventListener('change', () => {
      const plan = form.querySelector('[data-ck-selling-plan]');
      if (plan) plan.disabled = radio.value !== 'subscription';
      updatePrice();
    }));
    form.querySelector('[data-ck-selling-plan]')?.addEventListener('change', updatePrice);
    root.querySelectorAll('[data-ck-quantity]').forEach(button => button.addEventListener('click', () => {
      const quantity = form.elements.quantity;
      quantity.value = String(Math.max(1, (parseInt(quantity.value, 10) || 1) + Number(button.dataset.ckQuantity)));
      quantity.dispatchEvent(new Event('change', {bubbles:true}));
    }));
    thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => showPhoto(i)));
    root.querySelectorAll('[data-ck-thumb-scroll]').forEach(button => button.addEventListener('click', () => {
      const rail = root.querySelector('.ck-gallery-thumbs');
      rail?.scrollBy({top:Number(button.dataset.ckThumbScroll) * 250,behavior:'smooth'});
    }));
    root.querySelectorAll('[data-ck-gallery-step]').forEach(button => button.addEventListener('click', () => showPhoto(photoIndex + Number(button.dataset.ckGalleryStep))));
    const gallery = root.querySelector('.ck-gallery-stage');
    let startX = null;
    gallery?.addEventListener('touchstart', event => {startX = event.touches[0].clientX;}, {passive:true});
    gallery?.addEventListener('touchend', event => {
      if (startX === null) return;
      const distance = event.changedTouches[0].clientX - startX;
      if (Math.abs(distance) > 60) showPhoto(photoIndex + (distance < 0 ? 1 : -1));
      startX = null;
    }, {passive:true});
    const dialog = root.querySelector('[data-ck-image-dialog]');
    photos.forEach((button, index) => button.addEventListener('click', () => {
      const image = data.images[index];
      if (!image || !dialog?.showModal) return;
      dialog.querySelector('img').src = image.src;
      dialog.showModal();
    }));
    root.querySelector('[data-ck-close-dialog]')?.addEventListener('click', () => dialog.close());
    dialog?.addEventListener('click', event => {if (event.target === dialog) dialog.close();});
    const facts = root.querySelector('[data-ck-facts-dialog]');
    root.querySelector('[data-ck-open-facts]')?.addEventListener('click', () => facts?.showModal());
    root.querySelector('[data-ck-close-facts]')?.addEventListener('click', () => facts?.close());
    facts?.addEventListener('click', event => {if (event.target === facts) facts.close();});
    root.querySelectorAll('[data-ck-open-learn]').forEach(button => button.addEventListener('click', () => {
      const modal = document.getElementById(button.dataset.ckOpenLearn);
      modal?.showModal();
    }));
    root.querySelectorAll('[data-ck-close-learn]').forEach(button => button.addEventListener('click', () => button.closest('dialog')?.close()));
    if (add) form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy || !variant()?.available || !form.reportValidity()) return;
      busy = true;
      add.disabled = true;
      add.setAttribute('aria-busy', 'true');
      addLabel.textContent = 'Adding...';
      if (status) {status.hidden = true;status.setAttribute('role', 'status');}
      const viewCart = root.querySelector('[data-ck-view-cart]');
      if (viewCart) viewCart.hidden = true;
      try {
        const base = window.Shopify?.routes?.root || '/';
        const response = await fetch(base + 'cart/add.js', {method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this item. Please try again.');
        if (status) {status.hidden = false;status.textContent = 'Added to your cart.';}
        if (viewCart) viewCart.hidden = false;
        document.dispatchEvent(new CustomEvent('cart:refresh', {detail:{source:'catakor-product',productVariantId:select.value}}));
      } catch (error) {
        if (status) {status.hidden = false;status.setAttribute('role', 'alert');status.textContent = error.message || 'Unable to add this item. Please try again.';}
      } finally {
        busy = false;
        add.removeAttribute('aria-busy');
        updatePrice();
      }
    });
    const sticky = root.querySelector('[data-ck-sticky]');
    root.querySelector('[data-ck-sticky-add]')?.addEventListener('click', () => {if (add) form.requestSubmit(add);});
    if (sticky && add && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {sticky.hidden = entries[0].isIntersecting || entries[0].boundingClientRect.top > 0;}, {threshold:0});
      observer.observe(add);
      root._ckObserver = observer;
    }
    updatePrice();
    if (window.lucide) window.lucide.createIcons();
  }
  const initializeAll = () => document.querySelectorAll('[data-catak-product]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
  else initializeAll();
  document.addEventListener('shopify:section:load', initializeAll);
  document.addEventListener('shopify:section:unload', event => event.target.querySelector('[data-catak-product]')?._ckObserver?.disconnect());
})();
